import React, { useEffect, useState } from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  actionLabel = 'Confirmă',
  actionVariant = 'default',
  reasonLabel = 'Motiv (obligatoriu)',
  reasonPlaceholder = 'Descrie motivul acestei acțiuni (apare în jurnalul de audit)',
  requireTypedConfirmation = null,
  typedConfirmationHint = null,
  submitting = false,
  children = null,
  canSubmitExtra = true,
}) => {
  const [reason, setReason] = useState('');
  const [typed, setTyped] = useState('');
  const [localError, setLocalError] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setReason('');
      setTyped('');
      setLocalError(null);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const needsTyped = !!requireTypedConfirmation;
  const typedMatches = !needsTyped || typed.trim() === requireTypedConfirmation;
  const canSubmit =
    !submitting && reason.trim().length >= 4 && typedMatches && canSubmitExtra;

  const handleConfirm = async () => {
    if (!canSubmit) return;
    try {
      setLocalError(null);
      await onConfirm({ reason: reason.trim() });
    } catch (err) {
      setLocalError(err?.message || 'Acțiunea a eșuat. Reîncearcă.');
    }
  };

  return (
    <div className="confirm-modal-overlay" onClick={submitting ? undefined : onClose}>
      <div
        className="confirm-modal-card"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-modal-title"
      >
        <h3 id="confirm-modal-title" className="confirm-modal-title">
          {title}
        </h3>
        {description && (
          <p className="confirm-modal-description">{description}</p>
        )}

        {children}

        {needsTyped && (
          <div className="confirm-modal-field">
            <label htmlFor="confirm-modal-typed">
              {typedConfirmationHint ||
                `Pentru a continua, tastează exact: ${requireTypedConfirmation}`}
            </label>
            <input
              id="confirm-modal-typed"
              type="text"
              value={typed}
              onChange={(e) => setTyped(e.target.value)}
              disabled={submitting}
              autoComplete="off"
              spellCheck={false}
            />
          </div>
        )}

        <div className="confirm-modal-field">
          <label htmlFor="confirm-modal-reason">{reasonLabel}</label>
          <textarea
            id="confirm-modal-reason"
            value={reason}
            onChange={(e) => setReason(e.target.value.slice(0, 500))}
            placeholder={reasonPlaceholder}
            rows={3}
            disabled={submitting}
            maxLength={500}
          />
          <div className="confirm-modal-reason-meta">
            {reason.trim().length < 4
              ? 'Minim 4 caractere.'
              : `${500 - reason.length} caractere rămase`}
          </div>
        </div>

        {localError && (
          <div className="confirm-modal-error" role="alert">
            ⚠️ {localError}
          </div>
        )}

        <div className="confirm-modal-actions">
          <button
            type="button"
            className="confirm-modal-cancel"
            onClick={onClose}
            disabled={submitting}
          >
            Anulează
          </button>
          <button
            type="button"
            className={`confirm-modal-submit ${
              actionVariant === 'danger' ? 'danger' : ''
            }`}
            onClick={handleConfirm}
            disabled={!canSubmit}
          >
            {submitting ? 'Se procesează…' : actionLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
